export default class Accordion {
  constructor() {
    var accordion = document.querySelector('.accordion');
    var accordionInternal = document.querySelector('.accordion__internal');
    var accordionSync = document.querySelector('[data-accordion]');

    if (typeof (accordionInternal) != 'undefined' && accordionInternal != null) {
      var accordions = document.querySelectorAll('.accordion__internal');

      accordions.forEach(element => {
        element.nextElementSibling.addEventListener('click', function (e) {
          e.preventDefault();
          var self = this;
          var accordionContent = self.previousElementSibling;

          if (accordionContent.getAttribute('style') == null) {
            accordionContent.setAttribute('style', `height: ${accordionContent.querySelector('.accordion__table').offsetHeight}px;`);

            self.textContent = '- Ver menos';
          } else {
            accordionContent.removeAttribute('style');
            self.textContent = '+ Ver mais';
          }
        });
      });
    }

    if (typeof (accordion) != 'undefined' && accordion != null) {
      var accordions = document.querySelectorAll('.accordion');

      accordions.forEach(element => {
        element.getAttribute('data-accordion') ?
          null
          :
          element.querySelector('.accordion__title').addEventListener('click', function () {
            var self = this;
            var parent = self.parentNode;
            var accordionContent = parent.querySelector('.accordion__content');

            if (parent.getAttribute('style') == null) {
              parent.classList.add('accordion--active');
              parent.setAttribute('style', `height: ${accordionContent.offsetHeight + parent.offsetHeight}px;`);

              setTimeout(function() {
                parent.setAttribute('style', `height: auto; overflow: visible;`);
              }, 500);
            } else {
              parent.setAttribute('style', `height: ${accordionContent.offsetHeight + self.offsetHeight}px; overflow: visible;`);
              setTimeout(function() {
                parent.classList.remove('accordion--active');
                parent.removeAttribute('style');
              }, 100);
            }
          });
      });
    }

    if (typeof (accordionSync) != 'undefined' && accordionSync != null) {
      var accordionCaracteristicasSync = [...document.querySelectorAll('[data-accordion="caracteristicas"]')];
      var accordionCameraSync = [...document.querySelectorAll('[data-accordion="camera"]')];
      var accordionTelaSync = [...document.querySelectorAll('[data-accordion="tela"]')];
      var accordionResultadosSync = [...document.querySelectorAll('[data-accordion="resultados"]')];

      syncAccordions(accordionCaracteristicasSync);
      syncAccordions(accordionCameraSync);
      syncAccordions(accordionTelaSync);
      syncAccordions(accordionResultadosSync);
    }

    function syncAccordions(attrSync) {
      attrSync.forEach(element => {
        element.querySelector('.accordion__title').addEventListener('click', function () {
          attrSync.forEach(elementInside => {
            var accordionContent = elementInside.querySelector('.accordion__content');

            if (elementInside.getAttribute('style') == null) {
              elementInside.classList.add('accordion--active');
              elementInside.setAttribute('style', `height: ${accordionContent.offsetHeight + elementInside.offsetHeight}px;`);

              setTimeout(function() {
                elementInside.setAttribute('style', `height: auto; overflow: visible;`);
              }, 500);
            } else {
              elementInside.setAttribute('style', `height: ${elementInside.offsetHeight}px; overflow: visible;`);
              setTimeout(function() {
                elementInside.classList.remove('accordion--active');
                elementInside.removeAttribute('style');
              }, 100);
            }
          });
        });
      });
    }
  }
}

const accordion = new Accordion();